export enum Organism {
  HUMAN = 'human',
  MOUSE = 'mouse',
}

export type FamilyGenesType = {
  v_gene: FamilyType;
  j_gene: FamilyType;
};

export type FamilyType = {
  kFamily: object;
  hFamily: object;
  lFamily: object;
};

export enum FamilyOptions {
  VH = 'VH',
  VK = 'VK',
  VL = 'VL',
}

export interface FamilyColors {
  VH: string;
  VK: string;
  VL: string;
}

export enum DisplayType {
  COUNT = 'Count',
  PERCENTAGE = 'Percentage',
}
